/**
 * Putting a scenario into words.
 *
 * The Start block, its panel and the list page all describe the same record, so
 * the wording lives here rather than three times over.
 */

import { AOPActiveWindow, AOPScope } from '../../../types/AOPTypes';

export const AOP_WINDOW_LABELS: { [type: string]: string } = {
	all_hours: 'All day (24x7)',
	operating_hours: 'Business hours',
	after_hours: 'After hours',
	custom: 'Custom window',
};

export const activeWindowLabel = (activeWindow: AOPActiveWindow | null): string => {
	if (!activeWindow) {
		return '';
	}

	return AOP_WINDOW_LABELS[activeWindow.type]
		? AOP_WINDOW_LABELS[activeWindow.type]
		: activeWindow.type;
};

/**
 * Scope is `"all"` or a list of ids. The service returns ids without names, so
 * a narrowed scope is counted rather than listed — inventing names here would be
 * worse than saying how many.
 *
 * Singular and plural are both given rather than derived: stripping a trailing
 * "s" turns "priorities" into "prioritie".
 */
export const describeScope = (scope: AOPScope, one: string, many: string): string => {
	if (scope === 'all') {
		return `All ${many}`;
	}

	const count = scope ? scope.length : 0;
	return count === 1 ? `1 ${one}` : `${count} ${many}`;
};

export const describePriorityScope = (scope: AOPScope): string =>
	describeScope(scope, 'priority', 'priorities');

export const describeProblemTypeScope = (scope: AOPScope): string =>
	describeScope(scope, 'problem type', 'problem types');
